// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falF: CreateIconOptions = {
  "displayName": "FALF",
  "viewBox": "0, 0, 320, 512",
  "d": "M48 32C21.5 32 0 53.5 0 80L0 248 0 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192 208 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L32 240 32 80c0-8.8 7.2-16 16-16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L48 32z"
};
